import * as React from 'react'
import { LocationsButton } from './LocationsButton'
import { LocationsPopover } from './Popover/LocationsPopover'
import { LocationsProps } from '../typings'
import { useGetServiceLocationListPropHeaders, usePopoverState } from '../hooks'
import { LocationsListPopover } from '..'

export const LocationsPopoverButton: React.FC<LocationsProps> = (props) => {
  const {
    buttonStyle = 'text',
    field,
    isListView,
    listViewValue,
    matched,
  } = props
  const popoverState = usePopoverState()
  const { cellHeader } = useGetServiceLocationListPropHeaders(
    field,
    listViewValue,
  )
  return (
    <>
      <LocationsButton
        {...popoverState}
        matched={matched}
        listViewHeader={cellHeader}
        variant={buttonStyle}
      />
      {props.buttonStyle === 'chip' || !isListView ? (
        <LocationsPopover {...popoverState} {...props} />
      ) : (
        <LocationsListPopover {...popoverState} {...props} />
      )}
    </>
  )
}
LocationsPopoverButton.displayName = 'LocationsPopoverButton'
